export function createIpfsImageUrl(args) {
  return new URL(`/ipfs/${args.cid}${args.height ? `?img-height=${args.height}` : ""}`, args.baseUrl).toString();
}